import React, { useEffect, memo } from 'react';
import { HomeProvider, useHome } from './HomeContext';
import GeneralData from './GeneralData';
import '../../styles/home.css';
import UpdateData from './UpdateData';
import ModalR from '../../components/ModalR';
import { Button, TextField } from '@material-ui/core';
import Cookies from 'universal-cookie';
import { useGeneral } from '../../Context/GeneralContext';
import Cards from './Cards';
import TabIndi from './TabIndi';
import TabANDON from './TabANDON';
import ModalC from '../../components/ModalC';
import ModalIni from '../../components/ModalIni';
import ModalIniEsp from '../../components/ModalIniEsp';
import ModalTermEsp from '../../components/ModalTermEsp';
import ModalUE from '../../components/ModalUE';
import ModalScrap from '../../components/ModalScrap';
import { EstatusLineaComp, Homeviewbodyfield, ANDONcallscomp } from './HomeStyles';
import Llamados from '../../components/Llamados/Llamados';

const Home = memo(() => {
    const { celda, setOpenIni, setTerminarCorrida } = useGeneral();
    const {
        selectOrder,
        handleChangeOrder,
        meses,
        detailOrder,
        dias,
        startCorrida,
        cant,
        detailCorrida,
        status,
        openP,
        piezasM,
        piezasB,
        errorPb,
        errorPm,
        terminarCorrida,
        hErrorPm,
        hErrorPb,
        ordersF,
        getOrders,
        isCorridaActive,
        porUti,
        porEfi,
        mttr,
        mtbf,
        handleCloseP,
        handlePiezasB,
        handlePiezasM,
        openCierrePiezas,
    } = useHome();
    const cookie = new Cookies();
    const cierreBuenasMalas = process.env.REACT_APP_CIERRE_BUENAS_MALAS === 'true';

    // getOrders ya se llama en HomeContext al montar, no necesitamos llamarlo aquí también
    // Solo llamarlo si celda cambia después del montaje inicial
    const isInitialMount = React.useRef(true);
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return; // No llamar en el montaje inicial, HomeContext ya lo hace
        }
        getOrders(celda);
    }, [celda, getOrders]);

    return (
        <div className="homeView">
            <div className="homeView-head">
                <div className="homeView-head-title">
                    <h1 className="homeView-head-titulo">{cookie.get('nombreL')}</h1>
                    <p className="homeView-head-desc">Celda {cookie.get('celda')}</p>
                    <h4>
                        {dias[new Date().getDay()]}
                        {', '}
                        {new Date().toISOString().slice(8, 10)} {meses[new Date().getMonth()]}{' '}
                        {new Date().toISOString().slice(0, 4)}
                    </h4>
                </div>

                {process.env.REACT_APP_ALLOW_ANDON_BUTTONS === 'true' && (
                    <Llamados hideButtons={cookie.get('andon') !== 'true'} />
                )}
            </div>
            <div className="homeView-body">
                <Homeviewbodyfield
                    className="homeviewbodyfield-container"
                    style={{
                        height: (!isCorridaActive && ordersF.length === 0) ? 'auto' : undefined,
                        minHeight: (!isCorridaActive && ordersF.length === 0) ? 'auto' : undefined,
                        maxHeight: (!isCorridaActive && ordersF.length === 0) ? 'none' : undefined,
                    }}
                >
                    {process.env.REACT_APP_ALLOW_CORRIDA_INFO === 'true' && (
                        <div className="homeView-body-general">
                            <GeneralData
                                selectOrder={selectOrder}
                                handleChangeOrder={handleChangeOrder}
                                ordersF={ordersF}
                                detailOrder={detailOrder}
                                fechaIniReal={detailCorrida?.fechaIniReal}
                                startCorrida={startCorrida}
                                isCorridaActive={isCorridaActive}
                                setOpenIni={setOpenIni}
                                onTerminar={
                                    cierreBuenasMalas
                                        ? openCierrePiezas
                                        : () => setTerminarCorrida(true)
                                }
                            />
                        </div>
                    )}
                    {process.env.REACT_APP_ALLOW_STATUS_GRAPH === 'true' && (
                        <EstatusLineaComp className="estatuslinea-comp-container">
                            <UpdateData
                                detailOrder={detailOrder}
                                producido={detailCorrida?.producido ?? 0}
                                selectOrder={selectOrder}
                                cant={cant}
                                status={status}
                                startCorrida={startCorrida}
                                ordersF={ordersF}
                                isCorridaActive={isCorridaActive}

                            />
                        </EstatusLineaComp>
                    )}
                </Homeviewbodyfield>

                <ANDONcallscomp>
                    <div className="homeView-ANDONCalls-general">
                        <TabANDON />
                    </div>
                </ANDONcallscomp>


                {process.env.REACT_APP_ALLOW_KPI_GRAPH === 'true' && (
                    <div className={`homeView-body-graphs${!startCorrida ? ' homeView-body-graphs--hidden' : ''}`}>
                        <div className="homeView-tabindi-inline">
                            <TabIndi />
                        </div>
                        <Cards value={porUti} tipo={'%'} titulo={'% OEE'} showcontent={1} />
                        <Cards value={porEfi} tipo={'%'} titulo={'% TEEP'} showcontent={1} />
                        <Cards value={mtbf} tipo={'hh:mm'} titulo={'MTBF'} showcontent={0} />
                        <Cards value={mttr} tipo={'hh:mm'} titulo={'MTTR'} showcontent={0} />
                    </div>
                )}
            </div>

            <div>
                <ModalR
                    colorButton="primary"
                    open={openP}
                    buttonClass="popup-button"
                    popupsbclass="popupbp"
                    popupFlag={true}
                    popupTitle={
                        <div className="popuphead4">
                            <h2 className="popuptitle">Conteo de Piezas</h2>
                        </div>
                    }
                    popupBody={
                        <div className="popupbody1">
                            <div className="home-textfield">
                                <TextField
                                    variant="outlined"
                                    error={errorPb}
                                    helperText={hErrorPb}
                                    id="PiezasB"
                                    label="Ingrese cantidad total de piezas creadas"
                                    type="number"
                                    value={piezasB}
                                    onChange={(e) => handlePiezasB(e)}
                                />
                            </div>
                            <div className="home-textfield1">
                                <TextField
                                    variant="outlined"
                                    error={errorPm}
                                    helperText={hErrorPm}
                                    id="PiezasM"
                                    label="Ingrese cantidad total de piezas malas"
                                    type="number"
                                    value={piezasM}
                                    onChange={(e) => handlePiezasM(e)}
                                />
                            </div>
                            <div className="popupbottom1">
                                <div className="popupbpd7">
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        className="popup-button-s"
                                        onClick={handleCloseP}
                                        fullWidth
                                    >
                                        cancelar
                                    </Button>
                                </div>
                            </div>
                            <div className="popupbpd6">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="popup-button"
                                    onClick={terminarCorrida}
                                    type="submit"
                                    fullWidth
                                >
                                    Terminar Corrida
                                </Button>
                            </div>
                        </div>
                    }
                />
                <ModalC />
                <ModalScrap />
                <ModalIni />
                <ModalIniEsp />
                <ModalTermEsp />
                <ModalUE />
            </div>
        </div>
    );
});

let HomeCompView = () => {
    return (
        <HomeProvider>
            <Home />
        </HomeProvider>
    );
};

export default HomeCompView;
